import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = {
  key: 1,
  class: "fixed inset-0 z-[998] bg-slate-900/50 backdrop-blur-sm"
}
const _hoisted_3 = { class: "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-2xl" }
const _hoisted_4 = { class: "px-5 py-4" }
const _hoisted_5 = { class: "block text-sm font-bold text-slate-900" }
const _hoisted_6 = { class: "mt-2 flex flex-col gap-2 sm:flex-row" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "flex gap-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_15 = {
  key: 1,
  class: "rounded-lg border border-dashed border-slate-200 px-4 py-3 text-sm text-slate-400"
}
const _hoisted_16 = {
  key: 2,
  class: "overflow-hidden rounded-lg border border-slate-200"
}
const _hoisted_17 = { class: "text-sm font-semibold text-slate-700" }
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = ["disabled", "onClick"]
const _hoisted_21 = { class: "mt-8 space-y-5" }
const _hoisted_22 = { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }
const _hoisted_23 = { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_24 = { class: "text-2xl font-bold md:text-4xl" }
const _hoisted_25 = { class: "flex w-full flex-col gap-2 sm:w-auto sm:flex-row" }
const _hoisted_26 = { class: "grid grid-cols-1 gap-3 md:grid-cols-3" }
const _hoisted_27 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_28 = { class: "mt-2 text-2xl font-bold text-blue-900" }
const _hoisted_29 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_30 = { class: "mt-2 text-2xl font-bold text-amber-700" }
const _hoisted_31 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_32 = { class: "mt-2 text-2xl font-bold text-red-700" }
const _hoisted_33 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_34 = { class: "grid gap-3 sm:grid-cols-[160px_1fr] lg:max-w-2xl lg:grid-cols-[160px_320px]" }
const _hoisted_35 = { class: "relative" }
const _hoisted_36 = { class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_37 = { class: "overflow-x-auto" }
const _hoisted_38 = { class: "min-w-full" }
const _hoisted_39 = { class: "bg-blue-900" }
const _hoisted_40 = { class: "whitespace-nowrap px-5 py-3.5 text-left" }
const _hoisted_41 = { class: "whitespace-nowrap px-5 py-3.5 text-left" }
const _hoisted_42 = { class: "whitespace-nowrap px-5 py-3.5 text-left" }
const _hoisted_43 = { class: "whitespace-nowrap px-5 py-3.5 text-left" }
const _hoisted_44 = { class: "whitespace-nowrap px-5 py-3.5 text-left" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "px-5 py-4 align-middle" }
const _hoisted_47 = ["src", "alt"]
const _hoisted_48 = { class: "px-5 py-4 align-middle" }
const _hoisted_49 = { class: "font-semibold text-slate-900 whitespace-nowrap" }
const _hoisted_50 = { class: "mt-1 text-xs text-slate-400" }
const _hoisted_51 = { class: "px-5 py-4 text-sm font-semibold text-blue-900 whitespace-nowrap align-middle" }
const _hoisted_52 = { class: "px-5 py-4 align-middle" }
const _hoisted_53 = { class: "px-5 py-4 align-middle" }
const _hoisted_54 = { class: "inline-flex rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-600" }
const _hoisted_55 = { class: "max-w-[260px] px-5 py-4 text-sm text-slate-600 align-middle" }
const _hoisted_56 = ["title"]
const _hoisted_57 = { class: "px-5 py-4 align-middle" }
const _hoisted_58 = ["href"]
const _hoisted_59 = {
  key: 1,
  class: "text-sm text-slate-400"
}
const _hoisted_60 = { class: "px-5 py-4 text-sm text-slate-500 whitespace-nowrap align-middle" }
const _hoisted_61 = { class: "px-5 py-4 text-right align-middle whitespace-nowrap" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 px-6 py-4" }
const _hoisted_65 = { class: "text-xs text-slate-500" }
const _hoisted_66 = { class: "font-semibold text-slate-700" }
const _hoisted_67 = { class: "font-semibold text-slate-700" }
const _hoisted_68 = { class: "font-semibold text-slate-700" }
const _hoisted_69 = { class: "flex items-center gap-2" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = { class: "text-xs text-slate-500" }
const _hoisted_72 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import {
  GET_MERCHANDISES,
  DELETE_MERCHANDISE,
  GET_MERCHANDISE_CATEGORIES,
  POST_MERCHANDISE_CATEGORY,
  PUT_MERCHANDISE_CATEGORY,
  DELETE_MERCHANDISE_CATEGORY,
} from "@/store/merchandise.module";
import ModalForm from "../components/modal/FormMerchandise.vue";
import { useStore } from 'vuex';
import Breadcrumb from '../components/AppBreadcrumb.vue';
import Swal from 'sweetalert2';
import { formattedPrice } from '@/utils';
import IcTrash from '@/assets/svg/ic-trash.vue';
import IcEdit from '@/assets/svg/ic-edit.vue';
import IcPlus from '@/assets/svg/ic-plus.vue';
import AppSelect from '@/components/input/AppSelect.vue';
import SortButton from '@/components/table/SortButton.vue';

type SortDirection = 'asc' | 'desc';
type MerchandiseSortKey = 'name' | 'price' | 'stock' | 'kategori' | 'updatedAt';
type SortRule = {
  key: MerchandiseSortKey;
  direction: SortDirection;
};

type MerchandiseItem = {
  id: number;
  name?: string;
  image?: string;
  price?: number | string;
  stock?: number | string;
  description?: string;
  link?: string;
  kategori?: string;
  createdAt?: string;
  updatedAt?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MerchandiseView',
  setup(__props) {

const store = useStore();

const isOpened = ref(false); 
const isManageOpened = ref(false);
const isLoading = ref(true); 
const isLoadingCategories = ref(false);
const dataUpdate = ref<Partial<MerchandiseItem>>({}); 
const currentId = ref<string | undefined>(undefined); 
const page = ref(1);
const limit = ref(5);
const search = ref(""); 
const title = ref("Merchandise"); 
const sortRules = ref<SortRule[]>([{ key: 'updatedAt', direction: 'desc' }]);
const categoryOptions = ref<string[]>([]);
const deletingCategory = ref<string | null>(null);
const editingCategory = ref<string | null>(null);
const categoryName = ref("");
const isSavingCategory = ref(false);
let searchTimer: ReturnType<typeof setTimeout> | null = null;
const pageLimitOptions = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 100, label: 'Semua' },
];

const openModal = () => {
  isOpened.value = true;
};

const openManageModal = async () => {
  isManageOpened.value = true;
  await loadCategories();
};

const closeManageModal = () => {
  isManageOpened.value = false;
  cancelEditCategory();
};

const handleModalClose = async () => {
  isOpened.value = false;
  dataUpdate.value = {};
  currentId.value = undefined
  await getData();
};

const computedData = computed<MerchandiseItem[]>(() => {
  const merchandises = store.getters.merchandises;
  const items = merchandises?.data || [];
  return [...items].sort((a, b) => compareMerchandise(a, b, sortRules.value));
});

const pagination = computed(() => {
  const merchandises = store.getters.merchandises;
  return merchandises?.pagination || [];
});

const lowStockCount = computed(() => computedData.value.filter((item) => {
  const stock = Number(item?.stock || 0);
  return stock > 0 && stock <= 5;
}).length);
const emptyStockCount = computed(() => computedData.value.filter((item) => Number(item?.stock || 0) <= 0).length);

const normalizeText = (value: unknown) => String(value ?? '').toLowerCase();

const normalizeNumber = (value: unknown) => {
  const numeric = Number(value ?? 0);
  return Number.isFinite(numeric) ? numeric : 0;
};

const normalizeDate = (value: unknown) => {
  if (!value) return 0;
  const timestamp = new Date(String(value)).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

const compareValue = (left: string | number, right: string | number) => {
  if (typeof left === 'number' && typeof right === 'number') return left - right;
  return String(left).localeCompare(String(right), 'id', { numeric: true, sensitivity: 'base' });
};

const compareMerchandise = (
  left: MerchandiseItem,
  right: MerchandiseItem,
  rules: SortRule[],
) => {
  const getValue = (item: MerchandiseItem, key: MerchandiseSortKey) => {
    if (key === 'price' || key === 'stock') return normalizeNumber(item?.[key]);
    if (key === 'updatedAt') return normalizeDate(item?.updatedAt);
    return normalizeText(item?.[key]);
  };

  for (const rule of rules) {
    const result = compareValue(getValue(left, rule.key), getValue(right, rule.key));
    if (result !== 0) {
      return result * (rule.direction === 'asc' ? 1 : -1);
    }
  }

  return 0;
};

const defaultSortDirection = (key: MerchandiseSortKey): SortDirection =>
  key === 'name' || key === 'kategori' ? 'asc' : 'desc';

const sortPriority = (key: MerchandiseSortKey) => {
  const index = sortRules.value.findIndex((rule) => rule.key === key);
  return index === -1 ? 0 : index + 1;
};

const sortDirectionFor = (key: MerchandiseSortKey): SortDirection => {
  return sortRules.value.find((rule) => rule.key === key)?.direction || defaultSortDirection(key);
};

const toggleSort = (key: MerchandiseSortKey, event?: MouseEvent) => {
  const currentRule = sortRules.value.find((rule) => rule.key === key);
  const nextRule: SortRule = {
    key,
    direction: currentRule?.direction === 'asc' ? 'desc' : 'asc',
  };

  if (event?.shiftKey) {
    sortRules.value = currentRule
      ? sortRules.value.map((rule) => (rule.key === key ? nextRule : rule))
      : [...sortRules.value, { key, direction: defaultSortDirection(key) }];
    return;
  }

  sortRules.value = currentRule ? [nextRule] : [{ key, direction: defaultSortDirection(key) }];
};

const getData = async () => {
  isLoading.value = true;
  const params = {
    data:{
      search: search.value,
      limit: limit.value,
      page: page.value,
    } 
  };
  const data = await store.dispatch(GET_MERCHANDISES, params);
  isLoading.value = false;
  return data;
};

const loadCategories = async () => {
  isLoadingCategories.value = true;
  try {
    categoryOptions.value = await store.dispatch(GET_MERCHANDISE_CATEGORIES);
  } finally {
    isLoadingCategories.value = false;
  }
};

const startEditCategory = (category: string) => {
  editingCategory.value = category;
  categoryName.value = category;
};

const cancelEditCategory = () => {
  editingCategory.value = null;
  categoryName.value = "";
};

const submitCategory = async () => {
  const nextCategory = categoryName.value.trim();
  if (!nextCategory) return;

  isSavingCategory.value = true;
  try {
    if (editingCategory.value) {
      await store.dispatch(PUT_MERCHANDISE_CATEGORY, {
        oldCategory: editingCategory.value,
        category: nextCategory,
      });
    } else {
      await store.dispatch(POST_MERCHANDISE_CATEGORY, nextCategory);
    }

    cancelEditCategory();
    await Promise.all([getData(), loadCategories()]);
    Swal.fire({
      title: "Tersimpan",
      text: "Kategori merchandise telah disimpan.",
      icon: "success",
      confirmButtonColor: '#1e40af',
      confirmButtonText: "OK"
    });
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Gagal",
      text: err instanceof Error ? err.message : "Gagal menyimpan kategori merchandise.",
      confirmButtonColor: '#1e40af',
    });
  } finally {
    isSavingCategory.value = false;
  }
};

const onSearchInput = () => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    page.value = 1;
    getData();
  }, 350);
};

onMounted(async () => {
  await getData();
});

const formatDate = (dateString?: string) => {
  if (!dateString) return '-';

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };
  
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '-';

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
  const formattedDate = date.toLocaleDateString('en-US', options)
    .replace(/(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)/g, (matched) => monthNames[new Date(`${matched} 1`).getMonth()]);

  return formattedDate.replace('AM', 'AM').replace('PM', 'PM');
};

const stockBadgeClass = (stock: number | string | undefined) => {
  const value = Number(stock || 0);
  if (value <= 0) return 'bg-red-100 text-red-700';
  if (value <= 5) return 'bg-yellow-100 text-yellow-700';
  return 'bg-green-100 text-green-700';
};

const editItem = (item: MerchandiseItem) => {
  dataUpdate.value = { ...item };
  currentId.value = String(item.id); 
  isOpened.value = true;
};

const deleteItem = async (id: number) => {
   await Swal.fire({
    title: 'Hapus merchandise?',
    text: "Data ini tidak bisa dikembalikan.",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Ya, hapus',
    cancelButtonText: 'Batal'
  }).then(async (result) => {
          if (result.isConfirmed) {
            const params = { id: id };
            try {
              await store.dispatch(DELETE_MERCHANDISE, params);
              Swal.fire({
                title: "Terhapus",
                text: "Merchandise telah dihapus.",
                icon: "success",
                confirmButtonColor: '#1e40af',
                confirmButtonText: "OK"
              }).then(async () => {
                await getData();
              });
            } catch (err) {
              Swal.fire({
                icon: "error",
                title: "Gagal",
                text: err instanceof Error ? err.message : "Gagal menghapus merchandise.",
                confirmButtonColor: '#1e40af',
              });
            }
          }
        });
};

const deleteCategory = async (category: string) => {
  const result = await Swal.fire({
    title: 'Hapus kategori merch?',
    text: `Kategori "${category}" akan dilepas dari semua produk yang memakainya. Produk tidak akan dihapus.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Ya, hapus kategori',
    cancelButtonText: 'Batal'
  });

  if (!result.isConfirmed) return;

  deletingCategory.value = category;
  try {
    await store.dispatch(DELETE_MERCHANDISE_CATEGORY, category);
    await Promise.all([getData(), loadCategories()]);
    Swal.fire({
      title: "Terhapus",
      text: "Kategori merchandise telah dihapus.",
      icon: "success",
      confirmButtonColor: '#1e40af',
      confirmButtonText: "OK"
    });
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Gagal",
      text: err instanceof Error ? err.message : "Gagal menghapus kategori merchandise.",
      confirmButtonColor: '#1e40af',
    });
  } finally {
    deletingCategory.value = null;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: title.value }, null, 8, ["breadcrumb"]),
    (isOpened.value)
      ? (_openBlock(), _createBlock(ModalForm, {
          key: 0,
          id: currentId.value,
          title: `${currentId.value ? 'Edit' : 'Tambah'} ${title.value}`,
          data: dataUpdate.value,
          onClose: handleModalClose
        }, null, 8, ["id", "title", "data"]))
      : _createCommentVNode("", true),
    (isManageOpened.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (isManageOpened.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "fixed inset-0 z-[999] flex items-center justify-center p-4",
          onClick: closeManageModal
        }, [
          _createElementVNode("div", {
            class: "w-full max-w-[680px]",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", { class: "flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" }, [
                _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "text-lg font-bold text-slate-900" }, "Kelola Merchandise"),
                  _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "Kelola kategori merchandise yang dipakai pada katalog produk.")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700",
                  onClick: closeManageModal
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("svg", {
                    class: "h-5 w-5",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("form", {
                  class: "mb-5 rounded-lg border border-slate-200 bg-slate-50 p-4",
                  onSubmit: _withModifiers(submitCategory, ["prevent"])
                }, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(editingCategory.value ? 'Edit Kategori' : 'Tambah Kategori'), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((categoryName).value = $event)),
                      type: "text",
                      class: "min-w-0 flex-1 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 placeholder-slate-400 transition focus:outline-none focus:ring-2 focus:ring-blue-900/10",
                      placeholder: "Nama kategori merchandise",
                      disabled: isSavingCategory.value
                    }, null, 8, _hoisted_7), [
                      [_vModelText, categoryName.value]
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-900 px-4 py-2 text-sm font-bold text-white transition hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-50",
                        disabled: isSavingCategory.value || !categoryName.value.trim()
                      }, [
                        (!editingCategory.value)
                          ? (_openBlock(), _createBlock(IcPlus, {
                              key: 0,
                              class: "h-4 w-4"
                            }))
                          : (_openBlock(), _createBlock(IcEdit, {
                              key: 1,
                              class: "h-4 w-4"
                            })),
                        _createTextVNode(" " + _toDisplayString(isSavingCategory.value ? 'Menyimpan...' : editingCategory.value ? 'Simpan' : 'Tambah'), 1)
                      ], 8, _hoisted_9),
                      (editingCategory.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-100",
                            disabled: isSavingCategory.value,
                            onClick: cancelEditCategory
                          }, " Batal ", 8, _hoisted_10))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mt-2 text-xs text-slate-500" }, " Edit kategori akan memperbarui semua produk yang memakai kategori lama. ", -1))
                ], 32),
                _createElementVNode("div", _hoisted_11, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                    _createElementVNode("h4", { class: "text-sm font-bold text-slate-900" }, "Kategori Merchandise"),
                    _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Menghapus kategori akan mengosongkan kategori pada produk terkait. Produk tidak ikut dihapus.")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "inline-flex items-center justify-center rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50",
                    disabled: isLoadingCategories.value,
                    onClick: loadCategories
                  }, " Refresh ", 8, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (isLoadingCategories.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                          return _createElementVNode("div", {
                            key: i,
                            class: "h-11 w-full animate-pulse rounded-lg bg-slate-100"
                          })
                        }), 64))
                      ]))
                    : (!categoryOptions.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Belum ada kategori merchandise. "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryOptions.value, (category) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: category,
                              class: "flex items-center justify-between gap-3 border-b border-slate-100 px-4 py-3 last:border-b-0"
                            }, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(category), 1),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "inline-flex items-center gap-1.5 rounded-lg bg-blue-50 px-3 py-1.5 text-xs font-bold text-blue-700 transition hover:bg-blue-100 disabled:cursor-not-allowed disabled:opacity-50",
                                  disabled: isSavingCategory.value || deletingCategory.value === category,
                                  onClick: ($event: any) => (startEditCategory(category))
                                }, [
                                  _createVNode(IcEdit, { class: "h-3.5 w-3.5" }),
                                  _cache[16] || (_cache[16] = _createTextVNode(" Edit ", -1))
                                ], 8, _hoisted_19),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "inline-flex items-center gap-1.5 rounded-lg bg-red-50 px-3 py-1.5 text-xs font-bold text-red-600 transition hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-50",
                                  disabled: deletingCategory.value === category,
                                  onClick: ($event: any) => (deleteCategory(category))
                                }, [
                                  _createVNode(IcTrash, { class: "h-3.5 w-3.5" }),
                                  _createTextVNode(" " + _toDisplayString(deletingCategory.value === category ? 'Menghapus...' : 'Hapus'), 1)
                                ], 8, _hoisted_20)
                              ])
                            ]))
                          }), 128))
                        ]))
                ])
              ]),
              _createElementVNode("div", { class: "flex justify-end border-t border-slate-100 bg-slate-50 px-5 py-4" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100",
                  onClick: closeManageModal
                }, " Tutup ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("section", _hoisted_22, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_24, _toDisplayString(title.value), 1),
            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, " Kelola produk merchandise, stok, harga, dan tautan pembelian yang tampil pada halaman publik. ", -1))
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              class: "inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/60 bg-transparent px-5 py-2.5 text-sm font-bold text-white transition-all hover:-translate-y-px hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/70 sm:w-auto",
              onClick: openManageModal
            }, " Kelola Merchandise "),
            _createElementVNode("button", {
              class: "inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#003793] shadow-lg transition-all hover:-translate-y-px hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-white/70 sm:w-auto",
              onClick: openModal
            }, [
              _createVNode(IcPlus),
              _cache[18] || (_cache[18] = _createTextVNode(" Tambah Merchandise ", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Total Produk", -1)),
          _createElementVNode("p", _hoisted_28, _toDisplayString(pagination.value?.totalEntries || computedData.value.length), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Stok Rendah", -1)),
          _createElementVNode("p", _hoisted_30, _toDisplayString(lowStockCount.value), 1)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Stok Habis", -1)),
          _createElementVNode("p", _hoisted_32, _toDisplayString(emptyStockCount.value), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", null, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Per Halaman", -1)),
            _createVNode(AppSelect, {
              modelValue: limit.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((limit).value = $event)),
              options: pageLimitOptions,
              onChange: _cache[3] || (_cache[3] = () => { page.value = 1; getData() })
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Cari", -1)),
            _createElementVNode("div", _hoisted_35, [
              _cache[25] || (_cache[25] = _createElementVNode("svg", {
                class: "absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
                })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search).value = $event)),
                placeholder: "Cari merchandise...",
                class: "w-full rounded-lg border border-slate-200 bg-white py-2 pl-9 pr-4 text-sm text-slate-700 placeholder-slate-400 transition-all focus:outline-none focus:ring-2 focus:ring-[#8c8c94]/20",
                onInput: onSearchInput
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("table", _hoisted_38, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_39, [
                _cache[27] || (_cache[27] = _createElementVNode("th", { class: "w-20 whitespace-nowrap px-5 py-3.5 text-left text-sm font-semibold text-blue-100" }, "Gambar", -1)),
                _createElementVNode("th", _hoisted_40, [
                  _createVNode(SortButton, {
                    label: "Produk",
                    active: sortPriority('name') > 0,
                    direction: sortDirectionFor('name'),
                    priority: sortPriority('name'),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleSort('name', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _createElementVNode("th", _hoisted_41, [
                  _createVNode(SortButton, {
                    label: "Harga",
                    active: sortPriority('price') > 0,
                    direction: sortDirectionFor('price'),
                    priority: sortPriority('price'),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleSort('price', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _createElementVNode("th", _hoisted_42, [
                  _createVNode(SortButton, {
                    label: "Stok",
                    active: sortPriority('stock') > 0,
                    direction: sortDirectionFor('stock'),
                    priority: sortPriority('stock'),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleSort('stock', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _createElementVNode("th", _hoisted_43, [
                  _createVNode(SortButton, {
                    label: "Kategori",
                    active: sortPriority('kategori') > 0,
                    direction: sortDirectionFor('kategori'),
                    priority: sortPriority('kategori'),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleSort('kategori', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _cache[28] || (_cache[28] = _createElementVNode("th", { class: "whitespace-nowrap px-5 py-3.5 text-left text-sm font-semibold text-blue-100" }, "Deskripsi", -1)),
                _cache[29] || (_cache[29] = _createElementVNode("th", { class: "whitespace-nowrap px-5 py-3.5 text-left text-sm font-semibold text-blue-100" }, "Link", -1)),
                _createElementVNode("th", _hoisted_44, [
                  _createVNode(SortButton, {
                    label: "Diperbarui",
                    active: sortPriority('updatedAt') > 0,
                    direction: sortDirectionFor('updatedAt'),
                    priority: sortPriority('updatedAt'),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (toggleSort('updatedAt', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _cache[30] || (_cache[30] = _createElementVNode("th", { class: "whitespace-nowrap px-5 py-3.5 text-right text-sm font-semibold text-blue-100" }, "Aksi", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (isLoading.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(limit.value, (i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: i,
                      class: "border-b border-slate-100"
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (c) => {
                        return _createElementVNode("td", {
                          key: c,
                          class: "px-5 py-4"
                        }, [...(_cache[31] || (_cache[31] = [
                          _createElementVNode("div", { class: "h-4 w-full max-w-[120px] animate-pulse rounded bg-slate-100" }, null, -1)
                        ]))])
                      }), 64))
                    ]))
                  }), 128))
                : (!computedData.value.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [...(_cache[32] || (_cache[32] = [
                      _createElementVNode("td", {
                        colspan: "9",
                        class: "px-5 py-12 text-center text-sm italic text-slate-400"
                      }, " Tidak ada merchandise ditemukan. ", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(computedData.value, (u) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: u?.id,
                        class: "border-b border-slate-100 transition-colors hover:bg-blue-50/40"
                      }, [
                        _createElementVNode("td", _hoisted_46, [
                          _createElementVNode("img", {
                            class: "h-14 w-14 rounded-xl border border-slate-200 object-cover shadow-sm",
                            src: u?.image || require('@/assets/image/default.png'),
                            alt: u?.name || 'Merchandise'
                          }, null, 8, _hoisted_47)
                        ]),
                        _createElementVNode("td", _hoisted_48, [
                          _createElementVNode("p", _hoisted_49, _toDisplayString(u?.name || '-'), 1),
                          _createElementVNode("p", _hoisted_50, "Dibuat " + _toDisplayString(formatDate(u?.createdAt)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_51, _toDisplayString(_unref(formattedPrice)(u?.price)), 1),
                        _createElementVNode("td", _hoisted_52, [
                          _createElementVNode("span", {
                            class: _normalizeClass([stockBadgeClass(u?.stock), 'inline-flex rounded-full px-2.5 py-1 text-xs font-semibold'])
                          }, _toDisplayString(u?.stock ?? 0) + " stok ", 3)
                        ]),
                        _createElementVNode("td", _hoisted_53, [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(u?.kategori || 'Tanpa kategori'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_55, [
                          _createElementVNode("p", {
                            class: "max-h-10 overflow-hidden whitespace-pre-line",
                            title: u?.description || ''
                          }, _toDisplayString(u?.description || '-'), 9, _hoisted_56)
                        ]),
                        _createElementVNode("td", _hoisted_57, [
                          (u?.link)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: u.link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "inline-flex items-center gap-1 text-sm font-semibold text-blue-600 hover:text-blue-800 hover:underline"
                              }, [...(_cache[33] || (_cache[33] = [
                                _createTextVNode(" Lihat ", -1),
                                _createElementVNode("svg", {
                                  class: "h-3.5 w-3.5",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor",
                                  "stroke-width": "2.5"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                  })
                                ], -1)
                              ]))], 8, _hoisted_58))
                            : (_openBlock(), _createElementBlock("span", _hoisted_59, "-"))
                        ]),
                        _createElementVNode("td", _hoisted_60, _toDisplayString(formatDate(u?.updatedAt)), 1),
                        _createElementVNode("td", _hoisted_61, [
                          _createElementVNode("button", {
                            class: "mr-3 inline-flex items-center gap-1.5 rounded-full bg-blue-50 px-3 py-1.5 text-sm font-semibold text-blue-700 transition-colors hover:bg-blue-100",
                            onClick: _withModifiers(($event: any) => (editItem(u)), ["prevent"])
                          }, [
                            _createVNode(IcEdit),
                            _cache[34] || (_cache[34] = _createTextVNode(" Edit ", -1))
                          ], 8, _hoisted_62),
                          _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center gap-1.5 rounded-full bg-red-50 px-3 py-1.5 text-sm font-semibold text-red-600 transition-colors hover:bg-red-100",
                            onClick: _withModifiers(($event: any) => (deleteItem(u.id)), ["prevent"])
                          }, [
                            _createVNode(IcTrash),
                            _cache[35] || (_cache[35] = _createTextVNode(" Hapus ", -1))
                          ], 8, _hoisted_63)
                        ])
                      ]))
                    }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("span", _hoisted_65, [
            _cache[36] || (_cache[36] = _createTextVNode(" Menampilkan ", -1)),
            _createElementVNode("span", _hoisted_66, _toDisplayString(pagination.value?.start || 0), 1),
            _cache[37] || (_cache[37] = _createTextVNode(" - ", -1)),
            _createElementVNode("span", _hoisted_67, _toDisplayString(pagination.value?.end || 0), 1),
            _cache[38] || (_cache[38] = _createTextVNode(" dari ", -1)),
            _createElementVNode("span", _hoisted_68, _toDisplayString(pagination.value?.totalEntries || 0), 1),
            _cache[39] || (_cache[39] = _createTextVNode(" entri ", -1))
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("button", {
              class: "rounded-lg border border-slate-200 bg-white px-3.5 py-1.5 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40",
              disabled: page.value <= 1,
              onClick: _cache[10] || (_cache[10] = () => { page.value = pagination.value?.currentPage - 1; getData() })
            }, " Sebelumnya ", 8, _hoisted_70),
            _createElementVNode("span", _hoisted_71, "Halaman " + _toDisplayString(pagination.value?.currentPage || 1) + " dari " + _toDisplayString(pagination.value?.totalPages || 1), 1),
            _createElementVNode("button", {
              class: "rounded-lg border border-slate-200 bg-white px-3.5 py-1.5 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40",
              disabled: page.value >= pagination.value?.totalPages,
              onClick: _cache[11] || (_cache[11] = () => { page.value = pagination.value?.currentPage + 1; getData() })
            }, " Selanjutnya ", 8, _hoisted_72)
          ])
        ])
      ])
    ])
  ]))
}
}

})